import request from '@/utils/request'

export async function addNotice(data) {
  return request({
    url: '/notice/save',
    method: 'post',
    data,
  })
}
export async function updateNotice(data) {
    return request({
      url: '/notice/update',
      method: 'post',
      data,
    })
}
export async function updateStatus(data) {
    return request({
      url: '/notice/status/update',
      method: 'post',
      data,
    })
}
export async function delNotice(data) {
    return request({
      url: '/notice/delete',
      method: 'post',
      data,
    })
}
export async function getList(data) {
  return request({
    url: '/notice/page',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
    return request({
      url: '/notice/findById',
      method: 'post',
      data,
    })
}
export async function getNoticeTypeEnum(data) {
    return request({
      url: '/notice/typeEnum',
      method: 'get',
      params: data,
    })
}
export async function getNoticeStatusEnum(data) {
    return request({
      url: '/notice/statusEnum',
      method: 'get',
      params: data,
    })
}
export async function uploadNotice(data) {
    return request({
      url: '/notice/file/upload',
      method: 'post',
      data,
    })
}
export async function uploadSearch(data) {
    return request({
      url: '/notice/file/search',
      method: 'post',
      data,
    })
}
export async function uploadDel(data) {
    return request({
      url: '/notice/file/delete',
      method: 'post',
      data,
    })
}